import { useEffect, useState } from 'react';
import { ReactComponent as SoundSvg } from './sound.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../constants';

const Flashcard = ({ flashcard, imageURL, onDeleteFlashcard, showKorean }) => {
  const [flip, setFlip] = useState(showKorean);
  const [isStarred, setIsStarred] = useState(false);

  useEffect(() => {
    setFlip(showKorean);
  }, [showKorean]);

  const sound =
    flashcard.audioPath === null
      ? null
      : new Audio(`${API_BASE_URL}${flashcard.audioPath}`);

  const playSound = (event) => {
    event.stopPropagation();
    if (sound) {
      sound.play();
    }
  };

  const toggleStar = (event) => {
    event.stopPropagation();
    setIsStarred(!isStarred);
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    if (
      flashcard.isUserAdded &&
      window.confirm("Are you sure you want to delete this flashcard?")
    ) {
      onDeleteFlashcard();
    }
  };

  return (
    <div
      className={`card${flip ? ' flip' : ''}`}
      onClick={() => setFlip(!flip)}
    >
      <div className='front'>
        <div className='content-container'>
          {imageURL && (
            <div className='image-preview'>
              <img
                src={
                  flashcard.imgPath.startsWith('https://')
                    ? flashcard.imgPath
                    : `${API_BASE_URL}/${flashcard.imgPath}`
                }
                alt='Flashcard Image'
              />
            </div>
          )}

          <div className='content-wrapper'>
            <div className='content'>
              {flashcard.english || "No English Text Available"}
            </div>

            <div className='star-icon' onClick={toggleStar}>
              {isStarred ? '⭐️' : '☆'}
            </div>

            {flashcard.isUserAdded && (
              <div className='delete-icon' onClick={handleDelete}>
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ fontSize: '1.2rem', cursor: 'pointer' }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='back'>
        <div className='content-container'>
          <div className='content'>{flashcard.korean}</div>

          {sound && (
            <div className='sound' onClick={playSound}>
              <SoundSvg />
            </div>
          )}

          <div className='star-icon' onClick={toggleStar}>
            {isStarred ? '⭐️' : '☆'}
          </div>

          {flashcard.isUserAdded && (
            <div className='delete-icon' onClick={handleDelete}>
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ fontSize: '1.2rem', cursor: 'pointer' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Flashcard;
